import React, { useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import EmpHourList from '../../components/detail/EmpHourList';
import CustomTimeInput from '../tables/shared/CustomTimeInput';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import sv from 'date-fns/locale/sv';
import { useTranslation } from 'react-i18next';
import { EMPLOYEE_DETAILS_NO_INTERNAL_HOURS_LABEL } from '../../i18n/keyConstants';
registerLocale('sv', sv);

const EmpHourInfo = ({ hourInfo, firstDate }) => {
    const { t } = useTranslation(['employeeDetails']);


    const [startDate, setStartDate] = useState(
        moment()
            .subtract(1, 'month')
            .startOf('month')
            .toDate()
    );
    const [endDate, setEndDate] = useState(
        moment()
            .subtract(1, 'month')
            .endOf('month')
            .toDate()
    );

    const updateStartDate = (date) => {
        setStartDate(date);
        if (endDate < date) setEndDate(date);
    };

    return (
        <>
            {hourInfo && hourInfo.length ? (
                <section>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12 col-md-8 offset-md-2'>
                                <div className='row'>
                                    <div className='col-12 col-lg-10 offset-lg-1'>
                                        <div className='padding-top-30px d-flex justify-content-between align-items-center'>
                                            <span>
                                                <DatePicker
                                                    selected={startDate}
                                                    onChange={(date) => updateStartDate(date)}
                                                    dateFormat='yyyy-MM'
                                                    customInput={<CustomTimeInput />}
                                                    minDate={new Date(firstDate)}
                                                    maxDate={new Date()}
                                                    showMonthYearPicker
                                                    locale='sv'
                                                />
                                            </span>
                                            <span className='oi oi-arrow-right padding-left-15px padding-right-15px'></span>
                                            <span>
                                                <DatePicker
                                                    selected={endDate}
                                                    onChange={(date) => setEndDate(date)}
                                                    dateFormat='yyyy-MM'
                                                    customInput={<CustomTimeInput />}
                                                    minDate={startDate}
                                                    maxDate={new Date()}
                                                    showMonthYearPicker
                                                    locale='sv'
                                                    popperPlacement='bottom-end'
                                                />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <EmpHourList hourInfo={hourInfo} startDate={startDate} endDate={endDate} />
                    </div>
                </section>
            ) : (
                <div className='col-10 offset-1 col-md-6 offset-md-3 col-lg-4 offset-lg-4 padding-top-30px'>
                        <p className='text-center'>{t(EMPLOYEE_DETAILS_NO_INTERNAL_HOURS_LABEL)}</p>
                </div>
            )}
        </>
    );
};

export default EmpHourInfo;
